import axios from 'axios';

const API_URL =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_API_LOCAL}/tiller-back`
    : process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_API_PRODUCTION}/tiller-back`
      : `${process.env.REACT_APP_API_STAGING}/tiller-back`;

const tillerApi = {
  createBack(backData) {
    return axios.post(API_URL, backData);
  },

  sendBackIdToSalesforce(tillerDataToSend) {
    return axios.put(`${API_URL}/to-salesforce`, tillerDataToSend);
  },
};

export default tillerApi;



// WEBPACK FOOTER //
// ./src/api/tiller.js